import WebGLPointsLayer from 'ol/layer/WebGLPoints.js';
import VectorSource from "ol/source/Vector";

export const pointMap = ({ map, featureCollection, activeLayers, setActiveLayers }) => {
    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }

        const source = new VectorSource({});
                
        featureCollection.forEach((data) => {
            data.featureArray.forEach((feature) => {
                const clonedFeature = feature.clone();
                source.addFeature(clonedFeature);
            })
        })

        const style = {
            'circle-radius': 2.5,
            'circle-stroke-width': 1,
            'circle-stroke-color': "#fff",
            'circle-opacity': 0.9,
            'circle-fill-color': "#0067A3"
        };
        
        const layer = new WebGLPointsLayer({
            source: source,
            style: style,
            zIndex: 20
        })
    
        setActiveLayers([layer]);
    }

    const dismount = () => {
        setActiveLayers();
    }
    
    return { mount: mount, dismount: dismount };
}